module.exports = __webpack_public_path__ + "static/media/3、雄安新区体育教育基础设施投资运营模式分析咨询-min.bde29f01.jpg";